// extracted by mini-css-extract-plugin
export var alt = "AppLink-module--alt--6488f";
export var appLink = "AppLink-module--appLink--38fde";
export var arrowLink = "AppLink-module--arrowLink--a9407";
export var arrowLinkReverse = "AppLink-module--arrowLinkReverse--6d8ea";
export var backgroundLightOnDark = "AppLink-module--backgroundLightOnDark--3bc14";
export var backgroundLightOnDarkAlt = "AppLink-module--backgroundLightOnDarkAlt--ee177";
export var buttonLink = "AppLink-module--buttonLink--71bf2";
export var buttonLinkAlt = "AppLink-module--buttonLinkAlt--a2a43";
export var c2a = "AppLink-module--c2a--b81a6";
export var darkOnLight = "AppLink-module--darkOnLight--a7e9b";
export var external = "AppLink-module--external--80b20";
export var iconArrow = "AppLink-module--iconArrow--b8ec1";
export var iconArrowWrapper = "AppLink-module--iconArrowWrapper--5700b";
export var iconExternalArrow = "AppLink-module--iconExternalArrow--ad2a0";
export var iconExternalBox = "AppLink-module--iconExternalBox--ef0ac";
export var iconExternalWrapper = "AppLink-module--iconExternalWrapper--4b9c6";
export var largeExternal = "AppLink-module--largeExternal--097b8";
export var lightOnDark = "AppLink-module--lightOnDark--a7d7a";
export var marginTop = "AppLink-module--marginTop--3434f";
export var normalBodyText = "AppLink-module--normalBodyText--7341a";